import { Box, Button, Modal, Text, theme } from "@pallet-hq/hegel"
import AnimatedStar from "components/AnimatedStar"
import { ReactComponent as IntroIcon } from "components/icons/liketeam-intro.svg"
import { useLikeTeamAction } from "./hooks"

export const LikeTeamIntroductionModal = () => {
    const { isIntroModalOpen, hideIntroModal } = useLikeTeamAction()
    if (!isIntroModalOpen) return null

    return (
        <Modal
            width="551px"
            margin="20px 20px 40px 20px"
            isOpen={isIntroModalOpen}
            hideModal={hideIntroModal}
            showIcon={false}
            shouldCloseOnEsc
            shouldCloseOnOverlayClick
        >
            <Box
                display="flex"
                flexDirection="column"
                alignItems="center"
                gridGap="20px"
                borderRadius={theme.space.xsmall}
            >
                <Box display="flex" overflow="hidden" width="100%">
                    <IntroIcon />
                </Box>
                <Box display="flex" flexDirection="column" maxWidth="350px">
                    <Text
                        variant={["headlineMedium", "headlineLarge"]}
                        textAlign="center"
                    >
                        Mark which companies you’re interested in chatting with
                    </Text>
                    <Text
                        variant="uiSmall500"
                        color="gray600"
                        textAlign="center"
                    >
                        If it’s a mutual fit you’ll get connected immediately.
                    </Text>
                </Box>
                <Button
                    variant="secondary"
                    size="small"
                    onClick={hideIntroModal}
                >
                    <Box
                        display="flex"
                        gridGap="xsmall"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <AnimatedStar filled={false} />
                        Interested
                    </Box>
                </Button>
            </Box>
        </Modal>
    )
}
